// extracted by mini-css-extract-plugin
module.exports = {"button":"StrtrCancelButton_button__OXJfa"};